export const apiBase = "/api/V2";
export const baseSeller = "/api/V2";
export const baseBuyer = "/api/V2";
export const baseEngineer = "/api/V2";
export const storageServerPath = "/storage/";
